import { WorkplaceInsuranceCompaniesQuery } from '../../../../graphql/graphql';

export interface WorkplaceInsuranceCompany {
	code: string;
	name: string;
	numberCode: string;
}

export function getWorkplaceInsuranceCompanies(
	data?: WorkplaceInsuranceCompaniesQuery,
) {
	return getWorkplaceInsuranceCompaniesDetails(data).map(
		singleValue => singleValue.code,
	);
}

export function getWorkplaceInsuranceCompaniesDetails(
	data?: WorkplaceInsuranceCompaniesQuery,
): WorkplaceInsuranceCompany[] {
	if (!data?.meta?.value || !Array.isArray(data.meta.value)) {
		return [];
	}

	return data.meta.value.filter(
		(item: WorkplaceInsuranceCompany) => item?.numberCode,
	);
}
